module.exports = __webpack_public_path__ + "img/ski_sec3_bg.c6622d8e.jpg";